"use strict";

module.exports = function (Class, props) {
    var propTypes = Class.propTypes;
    var others = {};
    for (var key in props) {
        if (!(key in propTypes)) {
            others[key] = props[key];
        }
    }
    return others;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next-util@0.7.0@@alicd/next-util/lib/pick-others.js
// module id = 687
// module chunks = 0